import { makeAutoObservable } from 'mobx';
import { LiveDashboardView } from 'pages/Metrics/Metrics';

class UiStore {
  currentView = LiveDashboardView.Dashboard;

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentView = (view: LiveDashboardView) => {
    this.currentView = view;
  };
}

export default UiStore;
